@import 'styles/mixins';
@import 'styles/variables';

.moreItemsContainer {
  display: flex;
  flex-direction: column;
  gap: 1px;
  position: fixed;
  bottom: 0;
  width: calc(100% - 8px);
  padding: 19px 15px;
  background: var(--default-bg);
  border-radius: 8px;
  z-index: 1;

  [data-autopilot-system-redesign='on'] & {
    width: 100%;
  }

  @include for-phone-only {
    position: unset;
    background: transparent;
  }
}
